<script setup>
import { ref, onMounted } from 'vue'
import { register } from 'swiper/element/bundle'
import { useServiceStore } from '@stores/service'
import ServiceFrame from '@components/global/accents/ServiceFrame.vue'
import Button from '@components/global/forms/Button.vue'
import Arrow from '@components/global/accents/Arrow.vue'
import { Autoplay } from 'swiper/modules'
register()

const serviceStore = useServiceStore()
const swiper = ref(null)
const currentIndex = ref(0)

onMounted(() => {
	if (swiper.value?.swiper) {
		swiper.value.swiper.on('slideChange', () => {
			currentIndex.value = swiper.value.swiper.activeIndex
		})
	}
})

const breakpoints = ref({
	0: {
		slidesPerView: 1.2,
	},
	640: {
		slidesPerView: 2.2,
	},
	768: {
		slidesPerView: 2.2,
	},
	1024: {
		slidesPerView: 3.2,
	},
	1280: {
		slidesPerView: 3.6,
	},
	1536: {
		slidesPerView: 4.2,
	},
	1792: {
		slidesPerView: 5.2,
	},
})

const next = () => {
	if (swiper.value?.swiper) {
		const swiperInstance = swiper.value.swiper
		swiperInstance.isEnd ? swiperInstance.slideTo(0) : swiperInstance.slideNext()
	}
}

const previous = () => {
	if (swiper.value?.swiper) {
		const swiperInstance = swiper.value.swiper
		swiperInstance.isBeginning ? swiperInstance.slideTo(swiperInstance.slides.length - 1) : swiperInstance.slidePrev()
	}
}
</script>

<template>
	<section class="relative overflow-hidden bg-crowns-off-black py-10 pb-14 lg:py-20">
		<div class="container">
			<img class="hidden w-full lg:block" src="https://cdn.papercrowns.com/website/images/elements/lockups/our-services.svg" alt="Our Services" />
			<img class="block w-full lg:hidden" src="https://cdn.papercrowns.com/website/images/elements/lockups/services.svg" alt="Services" />

			<div class="relative">
				<!-- Arrows -->
				<Arrow class="absolute -left-5 top-[calc(50%-3.5rem)] z-20 md:left-0" direction="left" @click="previous" />
				<Arrow class="absolute -right-5 top-[calc(50%-3.5rem)] z-20 md:right-0" direction="right" @click="next" />

				<!-- Services -->
				<swiper-container ref="swiper" class="-mt-14 mb-10 md:-mt-24 lg:-mt-28" :breakpoints="breakpoints">
					<!-- :modules="[Autoplay]"
					:autoplay="{
						delay: 3500,
						pauseOnMouseEnter: true,
					}" -->
					<swiper-slide v-for="(service, index) in serviceStore.categories" :key="service.slug">
						<ServiceFrame :service="service" :is-active="index === currentIndex" />
					</swiper-slide>
				</swiper-container>
			</div>

			<Button mega="pointer" label="Our Services" :to="{ name: 'services' }">Our Services</Button>
		</div>
	</section>
</template>
